import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';
import { DriverSalaryAdjustmentsInfoItem } from './types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    driverTonarAdjustmentsInfo: builder.query<DriverSalaryAdjustmentsInfoItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/driverTonarAdjustments/${data.id}/info`,
      }),
    }),
  }),
});

export const { useDriverTonarAdjustmentsInfoQuery, useLazyDriverTonarAdjustmentsInfoQuery } = request;
